import _ from 'lodash';
import {MODALS} from 'common/domain/constants';
import {STATES} from 'common/domain/states';
import {VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG} from 'vacations-absences.module/common/domain/constants';

class TeamCalendarController {
  constructor($filter,
              vacationUserDataService,
              inceptionService,
              teamCalendarService,
              HelperDelegationsService) {
    'ngInject';
    this.filter = $filter;

    this.vacationUserDataService = vacationUserDataService;
    this.inceptionService = inceptionService;
    this.teamCalendarService = teamCalendarService;
    this.helperDelegationsService = HelperDelegationsService;

    this.loaded = false;
    this.employeeFilters = [];
    this.calendarLines = [];
    this.periodFilters = [];

    this.dateToday = new Date();
    this.year = this.dateToday.getFullYear();

    this.coachmarkData = VA_TEAM_CALENDAR_MODAL_COACHMARK_CONFIG;
  }

  $onInit() {
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;
    this._initData();
  }

  _initData() {
    this.userId = this.vacationUserDataService.getEmployee().userId;

    this.teamCalendarService.initData(this.userId, this.year)
      .then(({ rawEmployeeList, employeeList, employeesForSearch, hasDelegated, delegation }) => {
        this.rawEmployeeList = rawEmployeeList;
        this.employeeList = employeeList;
        this.calendarLines = this.teamCalendarService.formatEmployeeList(this.employeeList);
        this.employeesForSearch = employeesForSearch;
        this.hasDelegated = hasDelegated;
        this.delegation = delegation;
        this.loaded = true;
      });
  }

  get modalWarningDelegation() {
    return $(MODALS.WARNING_DELEGATION_MODAL);
  }

  isDisabled() {
    return this.isWageInProcess;
  }

  onChangeDate($event) {
    this.currentDate = $event.currentDate;
    this.onChangeFilters({filters: this.periodFilters});
  }

  onSearch() {
    return this.helperDelegationsService.onSearchEmployeeDelegations(this.employeesForSearch);
  }

  onSelectEmployeeSearch($event) {
    if (!this.employeeFilters.find(employee => employee.userId === $event.userId)) {
      this.employeeFilters.push($event);
    }
  }

  onChangeFilters({filters}) {
    this.periodFilters = filters;
    this.employeeList = this.rawEmployeeList;

    if (!this.loaded) {
      return;
    }

    this.employeeList = this.filter('managerYearInlineFilter')(this.employeeList, filters, this.currentDate);
    this.calendarLines = this.teamCalendarService.formatEmployeeList(this.employeeList);
  }

  onRemoveEmployeeFilter($event) {
    _.remove(this.employeeFilters, filter => filter.userId === $event.userId);
  }

  onCleanEmployeeFilters() {
    this.employeeFilters = [];
  }

  existFilters() {
    return !!this.employeeFilters.length;
  }

  inceptEmployee({employeeId}) {
    if (this.hasDelegated) {
      return this._showModalWarningDelegation();
    }

    this.inceptionService.incept(employeeId, 'team-calendar');
  }

  _showModalWarningDelegation() {
    this.modalWarningDelegation.modal('show');
  }

  yearChanges($event) {
    this.year = $event.year;
    this.$onInit();
  }
}

export default TeamCalendarController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/teamCalendar.controller.js